import React from 'react';
import classNames from 'classnames/bind';
import style from './styles.module.scss';

const cx = classNames.bind(style);

function EpisodeStatusLabel({ episodeStatus, className }) {
  const backgroundColor = (() => {
    // 작성중 --> PREPARING
    // 심사중 --> IN_SCREENING
    // 심사반려 --> REJECTED_BY_ADMIN
    // 모객준비중 --> CAN_BE_LAUNCHED
    // 모객중 --> FULLY_BOOKED || BEFORE_LAUNCH
    // 완료 --> FINISHED
    // 취소 --> CANCELED_BY_HOST || CANCELED_BY_SYSTEM || CANCELED_BY_ADMIN

    switch (episodeStatus) {
      case 'PREPARING':
        return '#ebcb9d';
      case 'IN_SCREENING':
        return '#fca021';
      case 'REJECTED_BY_ADMIN':
        return '#652a1c';
      case 'CAN_BE_LAUNCHED':
        return '#6191ff';
      case 'FULLY_BOOKED':
      case 'BEFORE_LAUNCH':
        return '#41a574';
      case 'FINISHED':
        return '#424242';
      case 'CANCELED_BY_SYSTEM':
      case 'CANCELED_BY_ADMIN':
      case 'CANCELED_BY_HOST':
        return '#d52121';
      default:
        return '#000';
    }
  })();

  const episodeStatuLabel = (() => {
    switch (episodeStatus) {
      case 'PREPARING':
        return '작성중';
      case 'IN_SCREENING':
        return '심사중';
      case 'REJECTED_BY_ADMIN':
        return '심사보류';
      case 'CAN_BE_LAUNCHED':
        return '모객준비중';
      case 'FULLY_BOOKED':
      case 'BEFORE_LAUNCH':
        return '모객중';
      case 'FINISHED':
        return '완료';
      case 'CANCELED_BY_SYSTEM':
      case 'CANCELED_BY_ADMIN':
      case 'CANCELED_BY_HOST':
        return '취소';
      default:
        return '';
    }
  })();

  return (
    <div className={cx('EpisodeStatusLabel', className)} style={{ backgroundColor }}>
      {episodeStatuLabel}
    </div>
  );
}

export default EpisodeStatusLabel;
